// extracted by mini-css-extract-plugin
export var childrenContainer = "_bh-0";
export var virtualScrollArea = "_bh-1";